module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("kaT5H"))).then(() => parcelRequire('37nVf'));